import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { AddressBookStore, AddressBookState } from './address-book.store';
import { AddressBook } from './models/address-book.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AddressBookQuery extends QueryEntity<AddressBookState> {

  constructor(protected store: AddressBookStore) {
    super(store);
  }

  // Get all contacts
  selectAllContacts(): Observable<AddressBook[]> {
    return this.selectAll();
  }

}
